import { useSuspenseQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { BulletinListResponseSchema } from '../../../common/generated/residentApiSchemas'
import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import { get } from '../apiClient'

import { toSupportedLanguage } from 'i18n/i18n'

interface UseAPIGetBulletinBoardBulletinsProps {
  contractId: string
}

export const useAPIGetBulletinBoardBulletins = ({
  contractId,
}: UseAPIGetBulletinBoardBulletinsProps) => {
  const { i18n } = useTranslation()
  const lang = toSupportedLanguage(i18n.resolvedLanguage)

  const { data } = useSuspenseQuery({
    queryKey: ['bulletinBoard', contractId, lang],
    queryFn: async () => {
      const searchParams = new URLSearchParams({ language: lang })
      const path = API_ENDPOINTS.BULLETIN_LIST.replace(
        ':contractUuid',
        contractId
      )
      return get(
        `${path}?${searchParams.toString()}`,
        BulletinListResponseSchema
      )
    },
  })

  return { bulletins: data.bulletins }
}
